// extracted by mini-css-extract-plugin
module.exports = {"group":"InputGroup_group__3Jxsp","inline":"InputGroup_inline__3JeW- InputGroup_group__3Jxsp"};